import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-[#23242A] text-white h-screen appheader overflow-y-auto p-6" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = {
  key: 1,
  class: "flex lg:flex-row items-center justify-center flex-col bg-[#2B2C32] rounded-xl"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_block_loading = _resolveComponent("block-loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.vg_selectedLocation.id)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_block_loading)
          ]),
          _cache[0] || (_cache[0] = _createElementVNode("p", { class: "py-4 -mt-24 text-center" }, "Please wait, while we are processing...", -1))
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("div", { class: "w-full" }, [
            _createElementVNode("div", { class: "bg-[#2B2C32] rounded-lg px-8 py-[16px]" }, [
              _createElementVNode("p", { class: "text-center text-theme-red" }, "Please select a location from the top left corner.")
            ])
          ], -1)
        ]))]))
  ]))
}